import styled from 'styled-components';

import LogoImage from '../../assets/images/logo.svg';
import Search from '../Search';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background-color: ${(props) => props.theme.colors.background};
`;

export const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 64px;
  padding: 0 2rem;
  background-color: ${(props) => props.theme.colors.background};
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  box-shadow: ${(props) => props.theme.shadows.sm};
`;

export const Logo = styled.img.attrs({
  src: LogoImage,
})`
  height: 36px;
  width: auto;
  object-fit: contain;
`;

export const HeaderSearch = styled(Search)`
  max-width: 400px;
`;

/* ── Main panel ── */
export const CodeContainer = styled.section`
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  animation: fadeInUp 0.35s ease both;

  @media (max-width: 600px) {
    padding: 1.5rem 1rem;
  }
`;

export const CodeBox = styled.div`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.875rem;
  background-color: ${(props) => props.theme.colors.primaryMuted};
  border: 1px solid ${(props) => props.theme.colors.primaryLight};
  border-radius: 99px;
`;

export const Code = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primary};
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: 'Inter', monospace;
`;

interface InfoContainerProps {
  loading?: boolean;
}

export const InfoContainer = styled.section<InfoContainerProps>`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 0.875rem;
`;

export const InfoBox = styled.div`
  display: ${(props) => (props.hidden ? 'none' : 'flex')};
  flex-direction: column;
  gap: 0.3rem;
  padding: 1rem;
  background-color: ${(props) => props.theme.colors.surface};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  transition: box-shadow ${(props) => props.theme.transitions.fast};

  &:hover {
    box-shadow: ${(props) => props.theme.shadows.sm};
  }
`;

export const InfoLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primary};
  text-transform: uppercase;
  letter-spacing: 0.6px;
`;

export const InfoData = styled.p`
  font-size: 15px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.title};
  line-height: 1.5;
  white-space: pre-line;
`;
